/** @format */

import videoGames from '../images/masters/videojuegos.jpeg';
import blender from '../images/masters/blender.png';
import print3D from '../images/masters/impresion3D.png';
import ZBrushCC5 from '../images/masters/cc5.png';
import blenderJovenes from '../images/masters/juniorPro.png';
import ZBrushUnreal from '../images/masters/character.png';
import rigging from '../images/masters/rigging.jpeg';
import riggingWebp from '../images/masters/rigging.webp';
import sculpturePrinting from '../images/masters/escultura_impresion.jpg';
import orco from '../images/masters/Orco.png';
import conceptArt from '../images/masters/conceptArt.jpg';
import mounstro from '../images/masters/mounstro.png';
import nox from '../images/masters/impresion3D.png';

const masters = [
	{
		title: 'Arte Conceptual + IA Online en vivo',
		description:
			'Aprende las bases conceptuales para crear personajes 2D de alta calidad, con un proceso creativo sólido y la IA como apoyo, no como reemplazo.',
		startDate: 'Thu, 8 Oct 2026 10:00:00 GMT-5',
		page: 'https://libel.academy/concept-art-ia/',
		image: conceptArt,
		imageWebp: conceptArt,
		video: 'https://youtu.be/-baMXVdFKgs?si=4Pd1EnX4fG-7Vzts',
	},
	{
		title: 'Máster en Blender',
		description: 'Aprende dese cero a nivel avanzado con mas de 10 entrenamientos especializados.',
		startDate: 'Thu, 05 Nov 2026 16:00:00 GMT-5',
		page: 'https://libel.academy/master-blender',
		image: blender,
		imageWebp: blender,
		video: 'https://www.youtube.com/watch?v=CXXX3NdTV68',
	},
	{
		title: 'Máster en ZBrush',
		description: 'Crea personajes en ZBrush y déjalos listos para el proceso de impresión 3D.',
		startDate: 'Mon, 26 Oct 2026 16:00:00 GMT-5',
		page: 'https://libel.academy/master-escultura-para-impresion',
		image: sculpturePrinting,
		imageWebp: sculpturePrinting,
		video: 'https://www.youtube.com/watch?v=9GzXcO0WEjI',
	},
	// {
	// 	title: 'Blender + IA para el diseño funcional',
	// 	description: ' Impresión en 3D - Figura estilizada con Iluminación.',
	// 	startDate: 'Mon, 10 Aug 2026 16:00:00 GMT-5',
	// 	page: 'https://www.libel.academy/blender-diseño-funcional',
	// 	image: diseno,
	// 	imageWebp: diseno,
	// 	video: 'https://youtu.be/LH1zV-Ra9jc',
	// },
	{
		title: 'Zira para videojuegos CC5 + ZBRUSH',
		description: 'Recibe la licencia de CHARACTER CREATOR 5 GRATIS DE POR VIDA.',
		startDate: 'Thu, 26 Nov 2026 16:00:00 GMT-5',
		page: 'https://libel.academy/master-personajes-estilizados',
		image: ZBrushCC5,
		imageWebp: ZBrushCC5,
		video: 'https://www.youtube.com/watch?v=8xj_pyfR1UQ&ab_channel=LIBELACADEMY',
	},
	{
		title: 'MOUNSTRO ACADEMY',
		description:
			'Máster en diseño y producción de criaturas para la industria del entretenimiento.',
		startDate: 'Mon, 06 Apr 2026 10:00:00 GMT-5',
		page: 'https://www.libel.academy/creacion-de-criaturas/',
		image: mounstro,
		imageWebp: mounstro,
		video: 'https://www.youtube.com/watch?v=MaD7VI8Lrm8',
	},
	{
		title: 'Blender para impresión 3D',
		description: 'Te enseñamos en dos meses a crear e imprimir personajes en BLENDER.',
		startDate: 'Wed, 30 Sep 2026 16:00:00 GMT-5',
		page: 'https://libel.academy/impresion-3d-con-blender/',
		image: nox,
		imageWebp: nox,
		video: 'https://www.youtube.com/watch?v=faTbxT5M3jo',
	},
	// {
	// 	title: '3D para jóvenes',
	// 	description: 'Crea tu primer personaje para IMPRESIÓN 3D.',
	// 	startDate: 'Tue, 30 Jun 2026 17:00:00 GMT-5',
	// 	page: 'https://www.libel.academy/blender-para-jovenes/',
	// 	image: blenderJovenes,
	// 	imageWebp: blenderJovenes,
	// 	video: 'https://www.youtube.com/watch?v=Qrw5QGFsUsY&ab_channel=LIBELACADEMY',
	// },
	{
		title: 'Máster en ZBrush Personaje para cine',
		description: 'Creación de Orco: Escultura de Criaturas Fantásticas.',
		startDate: 'Fri, 24 Jul 2026 16:00:00 GMT-5',
		page: 'https://libel.academy/personajes-para-cine',
		image: orco,
		imageWebp: orco,
		video: 'https://www.youtube.com/watch?v=4M4LZ3xt-RA&ab_channel=LIBELACADEMY',
	},
	{
		title: 'Máster en Rigging para Videojuegos y Animación',
		description: 'Vamos paso a paso y  crea Rig para animación y videojuegos desde cero.',
		startDate: 'Fri, 5 Sep 2022 19:00:00 GMT-5',
		page: 'https://libel.academy/master-rigging',
		image: rigging,
		imageWebp: riggingWebp,
		video: 'https://www.youtube.com/watch?v=chJJRqvsQWE',
	},
	{
		title: 'Máster en Personajes para Videojuegos AAA',
		description:
			'Crea personajes para videojuegos AAA donde usaremos ZBrush, Maya, Substance Painter entre otro software.',
		startDate: 'Tue, 29 Jul 2024 16:00:00 GMT-5',
		page: 'https://libel.academy/master-personajes-para-videojuegos',
		image: videoGames,
		imageWebp: videoGames,
		video: 'https://www.youtube.com/watch?v=4lTnLeO3HB4',
	},
	// {
	// 	title: 'ZBrush / Unreal 5',
	// 	description: 'Entrenamiento online con acompañamiento en vivo.',
	// 	startDate: 'Mon, 20 May 2023 19:00:00 GMT-5',
	// 	page: 'https://libel.academy/personajes-para-videojuegos',
	// 	image: ZBrushUnreal,
	// 	imageWebp: ZBrushUnreal,
	// 	video: 'https://www.youtube.com/watch?v=qiMF5Z-5cwY&ab_channel=LIBELACADEMY',
	// },
];

export default masters;
